<template>
    <Background
        :backPath="'/home'">
        <div v-if="fetching">
            <a-spin
                size="large"/>
        </div>
        <div
            class="list-area"
            v-else>
            <ListView
                v-if="haveData"
                :titles="titles"
                :columnWidths="columnWidths"
                :columnCells="columnCells"
                :fetchCallback="fetchFeedback"
                :listWidth="60"
            />
            <div
                class="no-feedback"
                v-else>
                没有用户反馈
            </div>
        </div>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"

 import ListView from "./ListView.vue"

 import { parseDate } from "../util/date.js"

 export default {
     name: 'UserFeedback',
     data() {
         return {
             showAddDialog: false,
             fetching: true,
             haveData: false,
             titles: ["消费者ID", "手机号", "反馈建议", "反馈时间"],
             columnWidths: [10, 15, 55, 20],
             columnCells: [
                 { value: "ConsumerId",
                   style: ""
                 },
                 { value: "Phone",
                   style: "text-align: end; padding-right: 10px;"
                 },
                 { value: "Comment",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "CreatedAt",
                   style: "text-align: end; padding-right: 10px;"
                 }
             ]
         }
     },
     components: {
         Background,
         ListView
     },
     computed: {

     },
     mounted() {
         this.test()
     },
     methods: {
         test() {
             const url = `${process.env.VUE_APP_API_SERVER}/consumer-feedback?offset=0`;
             var accessToken = localStorage.getItem('accessToken')

             var that = this
             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 this.fetching = false

                 console.log("Error: ", error)
             }).then(response => {
                 this.fetching = false

                 if (response.length > 0) {
                     this.haveData = true
                 }
             })
         },
         fetchFeedback(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/consumer-feedback?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             var that = this
             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log(response)

                 var data = response

                 for (var i = 0; i < data.length; i++) {
                     data[i].CreatedAt = parseDate(data[i].CreatedAt)
                 }

                 callback(data)
             })
         }
     },
 }
</script>

<style scoped>
 .list-area {
     width: 100%;
     height: 100%;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .no-feedback {
     font-size: 30px;
 }
</style>
